import { configureStore } from "@reduxjs/toolkit";
import { userSlice } from "./slice/user"; // Make sure this import is correct
import { commonSlice } from "./slice/common"; // Make sure this import is correct

const reducer = {
  user: userSlice.reducer, // Access the 'reducer' property of the userSlice
  common: commonSlice.reducer
};

const store = configureStore({
  reducer: reducer,
  devTools: true,
});

export default store;
